import api from "@/apis/api"

export const buildPdf = async (pdfId) => {
  const { data } = await api.post("/api/document/pdf", { pdfId }, { responseType: "blob" })
  return data
}

export const cachePdfData = async (payload) => {
  const { data } = await api.post("/api/document/pdf/cache", payload)

  return data
}

export const getCachePdfData = async (pdfId) => {
  const { data } = await api.get(`/api/document/pdf/cache/${pdfId}`)
  return data
}
